export const getUserPoolDetailsQuery = `query GetUserPoolDetails($userPoolName: String!) {
     getUserPoolDetails(userPoolName: $userPoolName) {
        details {
                application
                clientId
                id
                lastUpdated
                refreshTokenExp
                accessTokenExp
                idTokenExp
            }
            id
            name
            tokenSigningKeyUrl
            userCount
    }
}`;
